import dataURLtoFile from './dataURLtoFile';
import uploadVideoCover from './uploadVideoCover';
import { getMediaUrl } from './urlMakers';

function getVideoDetail(src: string): Promise<{
  coverUrl: string;
  duration: number;
}> {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.style.position = 'absolute';
    video.style.display = 'block';
    video.style.width = '100%';
    video.style.height = '0';
    video.style.visibility = 'hidden';
    video.muted = true;
    video.autoplay = true;
    video.onplay = async () => {
      video.pause();
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext('2d')!
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL('image/jpeg');
      const cover = dataURLtoFile(dataUrl, 'video.jpg');
      const coverUrl = await uploadVideoCover(cover);
      resolve({
        coverUrl,
        duration: video.duration,
      });
      document.body.removeChild(video);
    };
    document.body.appendChild(video);
    video.src = getMediaUrl(src);
  });
}

export default getVideoDetail;
